// extracted by mini-css-extract-plugin
export default {"permissionTableTitle":"PermissionSection_permissionTableTitle__nltvA"};